/* OmyBoat nearest-boats.js — Bateaux les plus proches (relax progressif) */
(function () {
  'use strict';
var isEN = /\/en(\/|$)/.test(window.location.pathname);

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[-_]/g, ' ').trim();
  }

  // ── Teste si un wrapper passe un filtre donné (ignore btaAvailable) ────
  function matches(w, f) {
    var pr    = parseFloat(w.dataset.price) || 0;
    var cap   = parseInt(w.dataset.capacity) || 0;
    var len   = parseFloat(w.dataset.length) || 0;
    var permit = w.dataset.permit === 'true';
    var ville  = norm(w.dataset.ville || w.dataset.port || '');
    var portAt = norm(w.dataset.portAttache || '');
    var type   = norm(w.dataset.type || '');
    var hasLoc = f.villes.length > 0 || f.ports.length > 0;

    if (hasLoc) {
      var villeMatch = f.villes.some(function (v) { return norm(v) === ville; });
      var portMatch  = f.ports.some(function (p) { return norm(p) === portAt; });
      if (!villeMatch && !portMatch) return false;
    }
    if (f.type   && !type.includes(norm(f.type)))        return false;
    if (f.pmin   && pr < f.pmin)                         return false;
    if (f.pmax   < Infinity && pr > f.pmax)              return false;
    if (f.cap    && cap < f.cap)                         return false;
    if (f.lmin   && len < f.lmin)                        return false;
    if (f.lmax   < Infinity && len > f.lmax)             return false;
    if (f.permit && permit !== false)                     return false;
    if (f.gps    && w.dataset.gps     !== 'true')        return false;
    if (f.douche && w.dataset.douche  !== 'true')        return false;
    if (f.bimini && w.dataset.bimini  !== 'true')        return false;
    if (f.skipper && w.dataset.skipper  !== 'true')      return false;
    // Intentionnel : on ignore data-bta-available ici
    return true;
  }

  // ── Niveaux de relax (cumulatifs, du moins au plus agressif) ──────────
  var RELAX_LEVELS = [
    {
      label: 'Sans les filtres d\'équipements',
      hasChange: function (f) {
        return f.gps || f.douche || f.bimini || f.skipper;
      },
      relax: function (f) {
        return Object.assign({}, f, {
          gps: false, douche: false,
          bimini: false, skipper: false
        });
      }
    },
    {
      label: 'Sans les contraintes de taille et de permis',
      hasChange: function (f) {
        return f.gps || f.douche || f.bimini || f.skipper
          || f.cap > 0 || f.lmin > 0 || f.lmax < Infinity || f.permit;
      },
      relax: function (f) {
        return Object.assign({}, f, {
          gps: false, douche: false, bimini: false, skipper: false,
          cap: 0, lmin: 0, lmax: Infinity, permit: false
        });
      }
    },
    {
      label: 'Sans filtre de type',
      hasChange: function (f) {
        return f.gps || f.douche || f.bimini || f.skipper
          || f.cap > 0 || f.lmin > 0 || f.lmax < Infinity || f.permit || !!f.type;
      },
      relax: function (f) {
        return Object.assign({}, f, {
          gps: false, douche: false, bimini: false, skipper: false,
          cap: 0, lmin: 0, lmax: Infinity, permit: false, type: ''
        });
      }
    },
    {
      label: 'Sans filtre de localisation',
      hasChange: function () { return true; }, // toujours dernier recours
      relax: function (f) {
        return Object.assign({}, f, {
          gps: false, douche: false, bimini: false, skipper: false,
          cap: 0, lmin: 0, lmax: Infinity, permit: false, type: '',
          villes: [], ports: []
        });
      }
    }
  ];

  // ── Affichage ──────────────────────────────────────────────────────────
  function renderSection(wrappers, label) {
    var section = document.getElementById('nearest-boats');
    var grid    = document.getElementById('nearest-boats-grid');
    var lbl     = document.getElementById('nearest-boats-label');
    if (!section || !grid || !lbl) return;

    grid.innerHTML = '';
    wrappers.forEach(function (w) {
      var clone = w.cloneNode(true);
      clone.style.display = '';
      clone.style.opacity = '';
      clone.style.pointerEvents = '';
      grid.appendChild(clone);
    });

    lbl.textContent = label;
    section.style.display = '';
  }

  function hideSection() {
    var section = document.getElementById('nearest-boats');
    if (section) section.style.display = 'none';
  }

  // ── API publique ───────────────────────────────────────────────────────
  window.showNearestBoats = function (f) {
    var allCards = Array.from(document.querySelectorAll('#boatsGrid .boat-card-wrapper'));
    var hasDates = !!(f.dateFrom && f.dateTo);
    var dateSuffix = hasDates ? ' \u2014 hors filtre de dates' : '';

    // Cas 1 : les filtres statiques passent mais BTA bloque → dates seules responsables
    var passStatic = allCards.filter(function (w) { return matches(w, f); });
    if (passStatic.length > 0) {
      renderSection(
        passStatic,
        (isEN ? 'These boats match your criteria, but are not available for these dates' : 'Ces bateaux correspondent à vos critères, mais ne sont pas disponibles pour ces dates')
      );
      return;
    }

    // Cas 2 : relax progressif des filtres statiques
    for (var i = 0; i < RELAX_LEVELS.length; i++) {
      var level = RELAX_LEVELS[i];
      if (!level.hasChange(f)) continue;
      var relaxed = level.relax(f);
      var found = allCards.filter(function (w) { return matches(w, relaxed); });
      if (found.length > 0) {
        renderSection(found, level.label + dateSuffix);
        return;
      }
    }

    hideSection();
  };

  window.hideNearestBoats = function () { hideSection(); };

  // ── Affiche les bateaux cachés EN BAS quand il y a déjà des résultats ─────
  window.showNearestBoatsAfterResults = function (f, allWrappers) {
    var hidden = allWrappers.filter(function (w) { return w.style.display === 'none'; });
    if (!hidden.length) { hideSection(); return; }

    // Titre adapté : "Voir aussi" plutôt que "les plus proches"
    var titleEl = document.querySelector('#nearest-boats .nearest-boats-title');
    if (titleEl) {
      titleEl.textContent = isEN ? '🚤 Our other available boats' : '🚤 Voir aussi nos autres bateaux';
    }

    var hasDates = !!(f.dateFrom && f.dateTo);
    var lbl;
    if (hasDates) {
      lbl = isEN
        ? 'These boats don\'t match all your criteria, or are unavailable for your dates'
        : 'Ces bateaux ne correspondent pas à tous vos critères, ou ne sont pas disponibles pour vos dates';
    } else {
      lbl = isEN
        ? 'These boats don\'t match all your current criteria'
        : 'Ces bateaux ne correspondent pas à tous vos critères actuels';
    }
    renderSection(hidden, lbl);
  };

})();
